import { render, staticRenderFns } from "./uploadApk.vue?vue&type=template&id=248dc36c"
import script from "./uploadApk.vue?vue&type=script&lang=js"
export * from "./uploadApk.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports